/**
 * Hook for fetching admin dashboard statistics.
 *
 * @module useAdminDashboardStats
 */

import { useQuery } from '@tanstack/react-query';
import { getAdminDashboardStats, type AdminDashboardStats } from '@/lib/adminApi';
import { STALE_TIME_FIVE_MINUTES } from '@/lib/constants';

const DEFAULTS: AdminDashboardStats = {
  totalQuestions: 0,
  totalContexts: 0,
  activeUsers: 0,
  levelDistribution: [],
  calculatedTotal: 0,
  questionsThisWeek: 0,
};

export function useAdminDashboardStats() {
  const { data, isLoading } = useQuery({
    queryKey: ['adminDashboardStats'],
    queryFn: getAdminDashboardStats,
    staleTime: STALE_TIME_FIVE_MINUTES,
  });

  return {
    stats: data ?? DEFAULTS,
    loading: isLoading,
  };
}
